module.exports = __webpack_public_path__ + "img/ukraine.9a8f121d.svg";